import { render, staticRenderFns } from "./directedInquiry.vue?vue&type=template&id=8b3ef528&scoped=true"
import script from "./directedInquiry.vue?vue&type=script&lang=js"
export * from "./directedInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3ef528",
  null
  
)

export default component.exports